import styled from '@emotion/styled/macro';
import {theme} from '@themes';

export const DesktopViewFlex = styled.div`
  display: none;
  ${theme.breakpoints.up('sm')} {
    display: flex;
  }
`;

export const MobileViewFlex = styled.div`
  display: none;
  ${theme.breakpoints.down('sm')} {
    display: flex;
  }
`;
